import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-clm-res-unit-information',
    imports: [FormsModule, MatIcon],
    templateUrl: './clm-res-unit-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-res-unit-information.component.css'
})
export class ClmResUnitInformationComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  modelSelection!: GuruEntity;
  configurationSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.UNIT_INFORMATION;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.modelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USModel');
    this.configurationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USConfiguration');
    this.sizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
